<template>
  <div class="container mx-auto my-10 p-4">
    <div class="w-full place-content-center">
      <div class="w-full p-4 text-center p-mobile">
        <div class="card-header p-4">
          <h2 v-if="language=='en'">Hello {{_user.name}}</h2>
          <h2 v-else>您好 {{_user.name}}</h2>
        </div>

        <div class="card-body p-4" v-if="hasRecommendation(chosenAssessment)">
          <div class="bg-white rounded-md p-4">
            <Recommendation
              :recommendation="chosenAssessment.main_recommendation"
              :language="language"
            />
          </div>

          <!-- <Button
            class="w-full"
            :disabled="disableButton"
            :label="language == 'en' ? 'Proceed to Checkout' : 'Proceed to Checkout'"
            @click="gotoCheckout"
          /> -->
        </div>

        <div class="card-body p-4 p-mobile">
          <div class="bg-white rounded-md p-4 p-mobile">
            <div class="card-header p-2 assessment-title">
              <h4 v-if="language =='en'">Assessments</h4>
              <h2 v-else>Assessments</h2>
            </div>
            <AssessmentTable
              v-show="chosenAssessment == null"
              :assessments="assessments"
              :language="language"
              @viewAssessment="viewAssessment"
              @deleteAssessment="showDeleteAssessmentModal"
              @editAssessment="showEditAssessmentModal"
              @setMain="showSetMainModal"
            />

            <AssessmentSummary
              v-if="chosenAssessment != null"
              :assessment="chosenAssessment"
              :language="language"
            />
          </div>
        </div>

        <div class="card-body p-4" v-show="orders.length">
          <div class="bg-white rounded-md p-4">
            <div class="card-header p-2">
              <h4 v-if="language =='en'">Orders</h4>
              <h2 v-else>Orders</h2>
            </div>
            <OrderTable :orders="orders" :language="language" @deleteOrder="showDeleteOrderModal" />
          </div>
        </div>
      </div>
    </div>

    <modal name="delete-assessment-modal">
      <div class="p-6 text-center">
        <h4 class="my-4">Delete Assessment</h4>
        <p>Are you sure you want to delete Assessment [{{assessmentToDelete ? assessmentToDelete.id : ''}}]?</p>
        <p
          v-if="hasRecommendation(assessmentToDelete) "
          class="text-red-500"
        >This Assessment has a recommendation ready</p>
        <div class="my-4 text-center">
          <button
            class="p-5 m-4 text-white w-1/4 rounded"
            style="background:#88ad3f"
            @click="deleteAssessment"
          >YES</button>

          <button
            class="p-5 m-4 bg-red-500 text-white w-1/4 rounded"
            @click="hideDeleteAssessmentModal"
          >NO</button>
        </div>
      </div>
    </modal>

    <modal name="delete-order-modal">
      <div class="p-6 text-center">
        <h4 class="my-4">Delete Order</h4>
        <p>Are you sure you want to delete Order [{{orderToDelete ? orderToDelete.id : ''}}]?</p>
        <div class="my-4 text-center">
          <button
            class="p-5 m-4 text-white w-1/4 rounded"
            style="background:#88ad3f"
            @click="deleteOrder"
          >YES</button>

          <button
            class="p-5 m-4 bg-red-500 text-white w-1/4 rounded"
            @click="hideDeleteOrderModal"
          >NO</button>
        </div>
      </div>
    </modal>

    <modal name="set-main-assessment-modal">
      <div class="p-8 text-center">
        <h4 class="my-4">Set Main Assessment</h4>
        <p>Are you sure you want to set this assessment as main?</p>
        <div class="my-4 text-center">
          <button
            :disabled="disableButton"
            class="p-5 m-4 text-white w-1/4 rounded"
            style="background:#88ad3f"
            @click="setMainAssessment"
          >YES</button>

          <button class="p-5 m-4 bg-red-500 text-white w-1/4 rounded" @click="hideSetMainModal">NO</button>
        </div>
      </div>
    </modal>

    <modal name="create-assessment-modal">
      <div class="p-8 text-center">
        <h4 class="my-4">Create Assessment</h4>
        <p>Are you sure you want to create a new assessment?</p>
        <div class="my-4 text-center">
          <button
            :disabled="disableButton"
            class="p-5 m-4 text-white w-1/4 rounded"
            style="background:#88ad3f"
            @click="createAssessment"
          >YES</button>

          <button
            class="p-5 m-4 bg-red-500 text-white w-1/4 rounded"
            @click="$modal.hide('create-assessment-modal')"
          >NO</button>
        </div>
      </div>
    </modal>

    <modal name="edit-assessment-modal">
      <div class="p-2 text-center">
        <h4 class="my-4">Edit Assessment</h4>
        <p>This Assessment has a completed Recommendation.</p>
        <p>Are you sure you wish to make changes to this Assessment?</p>
        <div class="my-4 text-center">
          <button
            class="p-5 m-4 text-white w-1/4 rounded"
            style="background:#88ad3f"
            @click="gotoAssessment(assessmentToEdit.id)"
          >YES</button>

          <button
            class="p-5 m-4 bg-red-500 text-white w-1/4 rounded"
            @click="hideEditAssessmentModal"
          >NO</button>
        </div>
      </div>
    </modal>

    <Button
      v-show="chosenAssessment == null"
      class="w-full"
      :label="language == 'en' ? 'Create New Assessment' : '创建新评估'"
      @click="showCreateAssessmentModal"
    />

    <Button
      v-show="chosenAssessment != null"
      class="w-full"
      :label="language == 'en' ? 'Go Back' : '返回'"
      @click="chosenAssessment = null"
    />

    <Button class="w-full" :label="language == 'en' ? 'Take Survey' : '参加调查'" @click="gotoSurvey" />

    <Button class="w-full" id="logout" :label="language == 'en' ? 'Logout' : '退出'" @click="logout" />
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

import AssessmentTable from "./Dashboard/AssessmentTable";
import AssessmentSummary from "./Dashboard/AssessmentSummary";
import Recommendation from "./Dashboard/Recommendation";
import OrderTable from "./Dashboard/OrderTable";
import Button from "./forms/Button.vue";

export default {
  props: ["user"],
  components: {
    AssessmentTable,
    AssessmentSummary,
    OrderTable,
    Recommendation,
    Button
  },
  data() {
    return {
      assessments: [],
      orders: [],
      chosenAssessment: null,
      assessmentToDelete: null,
      assessmentToEdit: null,
      assessmentToSetMain: null,
      orderToDelete: null,
      disableButton: false
    };
  },
  computed: {
    ...mapGetters({
      language: "clientLanguage"
    }),
    _user() {
      return JSON.parse(this.user);
    }
  },
  async created() {
    await this.loadAllAssessments();
    await this.loadAllOrders();
  },
  methods: {
    hasRecommendation(assessment) {
      if (assessment == null) {
        return false;
      }

      if (assessment.main_recommendation_id) {
        return true;
      }

      return false;
    },
    showSetMainModal(assessment) {
      this.assessmentToSetMain = assessment;
      this.$modal.show("set-main-assessment-modal");
    },
    hideSetMainModal() {
      this.assessmentToSetMain = null;
      this.$modal.hide("set-main-assessment-modal");
    },
    async setMainAssessment() {
      this.disableButton = true;
      try {
        let result = await axios.post("/dashboard/set-main", {
          assessmentID: this.assessmentToSetMain.id,
          user_id: this._user.id
        });
        await this.loadAllAssessments();
      } catch (error) {
        console.log(error);
      }
      this.disableButton = false;
      this.hideSetMainModal();
    },
    showCreateAssessmentModal() {
      this.$modal.show("create-assessment-modal");
    },
    gotoAssessment(id) {
      window.location.href = "assessment?assessment_id=" + id;
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        window.location.href = "/";
      });
    },
    gotoSurvey() {
      window.location.href = "/survey";
    },
    async createAssessment() {
      this.disableButton = true;
      let result = await axios.post("/dashboard/new");
      this.disableButton = false;

      // TODO: I don't think pushing is the correct way, probablly should do loadAllAssessemnts;
      // Need to look into this a bit more though
      if (result.data.id) {
        this.assessments.push(result.data);
      }
      this.$modal.hide("create-assessment-modal");
    },
    showEditAssessmentModal(assessment) {
      // Newly created assessments don't even have a recommendations property
      if (!assessment.recommendations) {
        this.gotoAssessment(assessment.id);
      }

      if (assessment.recommendations.length) {
        this.$modal.show("edit-assessment-modal");
        this.assessmentToEdit = assessment;
      } else {
        this.gotoAssessment(assessment.id);
      }
    },
    hideEditAssessmentModal() {
      this.assessmentToEdit = null;
      this.$modal.hide("edit-assessment-modal");
    },
    viewAssessment(assessment) {
      this.chosenAssessment = assessment;
    },
    showDeleteAssessmentModal(assessment) {
      this.assessmentToDelete = assessment;
      this.$modal.show("delete-assessment-modal");
    },
    hideDeleteAssessmentModal() {
      this.assessmentToDelete = null;
      this.$modal.hide("delete-assessment-modal");
    },
    showDeleteOrderModal(order) {
      this.orderToDelete = order;
      this.$modal.show("delete-order-modal");
    },
    hideDeleteOrderModal() {
      this.orderToDelete = null;
      this.$modal.hide("delete-order-modal");
    },
    async deleteOrder() {
      let result = await axios.post("/dashboard/delete-order", {
        orderID: this.orderToDelete.id
      });
      console.log("result :>> ", result);
      if (result.status == 200) {
        await this.loadAllOrders();
        this.$modal.hide("delete-order-modal");
      }
    },
    async deleteAssessment() {
      let result = await axios.post("/dashboard/delete-assessment", {
        assessmentID: this.assessmentToDelete.id
      });
      console.log("result :>> ", result);
      if (result.status == 200) {
        await this.loadAllAssessments();
        this.$modal.hide("delete-assessment-modal");
      }
    },
    viewTable() {
      this.chosenAssessment = null;
    },
    async loadAllAssessments() {
      let allAssessmentsResponse = await axios.post(
        "/dashboard/all-assessments",
        { user_id: this._user.id }
      );
      if (allAssessmentsResponse.data) {
        this.assessments = allAssessmentsResponse.data;
      }
    },
    async loadAllOrders() {
      let allOrderResponse = await axios.post("/dashboard/all-orders", {
        user_id: this._user.id
      });
      if (allOrderResponse.data) {
        this.orders = allOrderResponse.data;
      }
    },
    async gotoCheckout() {
      this.disableButton = true;
      let checkoutResponse = await axios.post(
        "/dashboard/proceed-to-checkout",
        {
          assessmentID: this.chosenAssessment.id,
          mainRecommendationID: this.chosenAssessment.main_recommendation_id
        }
      );
      this.disableButton = false;

      let orderID = checkoutResponse.data.id;
      window.location.href = `checkout?order=${orderID}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  .p-mobile {
    padding: 0;
  }

  .assessment-title {
    background-color: #3166b0;
    color: #fff;
  }
}
</style>
